export const TableDataCellType = Object.freeze({
    Text: 'text',
    Bool: 'bool',
    Actions: 'actions',
});
